<template>
    
    
    <section class="subscription-banner">
        <div class="container-large">
            <div class="row align-items-center">
                <div class="col-md-8">
                    <!-- <h4>Daily Video Exercise!</h4>
                    <img src="@/assets/images/play-button.png" alt="" class= my-3> -->
                    <h2>Subscription</h2>
                    <p>With all subscription levels, you instantly become an exclusive member of the ROCKSTAR Backstage Pass Club!</p>
                    <p class="p-sm">With all subscription levels, you instantly become an exclusive member of the ROCKSTAR Backstage Pass Club!</p>
                </div>
                <div class="col-md-4 img-col">
                    <img src="@/assets/images/subscription-banner-img.png" alt="" class= "w-100">
                </div>
            </div>
        </div>
    </section>
    
    
       <section class="pricing-plan">
        <div class="container-large">
            <div class="row align-items-center">
                <div class="col-lg-4">
                    <div class="pricing-box">
                        <h2>Basic Plan</h2>
                        <h4>$9.99/month</h4>
                        <p>You’ll get</p>
                        <ul class="list-style">
                          <li>Earn Free Coins Every Month: This allows you to download Premium content, absolutely free.</li>

                          <li>Favorite Daily ROCKSTAR(t) Your Day videos: These videos disappear daily.  With this special perk, you can save (or “favorite”) up to 5 of them per month! This way, you can watch them again and again. And, you can share them with friends for free!</li>

                           <li>Change Audio Background: This is a MUST if you are really committed to doing your favorite meditations and hypnosis recordings on a regular basis.  You get complete control of the sounds and soothing images that go along with the recordings.  It’s like getting to design your favorite sacred space in your mind, based on your own good taste!</li>

                          <li>Free Sharing with Friends: Often, you will come across content on the app that someone you know or love could really use.  Go ahead and share it, absolutely FREE!</li>

                          <li>Free Surprise Perks:  The more you use the app, the more free stuff will come your way.  Keep those notifications on, so you don’t miss it!</li>
                        </ul>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="pricing-box center">
                        <h2>Premium</h2>
                        <h4>$99/year</h4>
                        <h5>And annual $99</h5>
                        <p>You get</p>
                            <ul class="list-style">
                          <li> EVERYTHING*!</li>  

                          <li>Watch Offline Feature: You can download unlimited content, and watch offline.</li>  

                          <li>Free Live Zoom Sessions with Sandy.</li>  

                          <li>Change Audio Background: This is a MUST if you are really committed to doing your favorite meditations and hypnosis recordings on a regular basis.  You get complete control of the soothing sounds and images that go along with the recordings.  It’s like getting to design your favorite sacred space in your mind, based on your own good taste!</li>  

                          <li> Free Sharing with Friends: Often, you will come across content on the app that someone you know or love could really use.  Go ahead and share it, absolutely FREE!</li>  

                          <li>Free Surprise Perks:  The more you use the app, the more free stuff will come your way.  Keep those notifications on, so you don’t miss it!</li>  

                          <li>Favorite Daily ROCKSTAR(t) Your Day videos: These videos disappear daily.  With this special perk, you can save (or “favorite”) as many as you’d like! This way, you can watch them all again and again. And, you can share them with friends for free!</li>  

                          <li>Free Exclusive Downloads.</li>  

                          <li>Free Online Courses.</li>  

                          <li>Even MORE Free Perks! The more you use the app, the more free stuff will come your way.  Keep those notifications on, so you don’t miss it!</li>  

                          <li>Unlock ALL Premium Content! (No coins necessary.  It’s all FREE for you!)</li>  

                          <li>EARN Additional FREE Months: The more you use the app, the more free months you can earn.  We’ll tack them onto the end of your subscription, just to keep it going, at absolutely no extra charge to you. Nothing for you do to.  We’ll just take car of it!</li>  
                        </ul>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="pricing-box">
                        <h2>Free Plan</h2>
                        <p>Free subscriptions include:</p>
                            <ul class="list-style">
                              <li>Daily ROCKSTAR(t) Your Day videos: These videos disappear daily. </li>

                              <li>Free content (It's limited, BUT, you can purchase coins, and buy anything you'd like on the app!)</li>

                              <li>Earn FREE coins, just by using the app daily. As you increase your daily streak, you earn more free coins to use for purchasing more content. </li>

                              <li>Free Sharing with Friends: Often, you will come across content on the app that someone you know or love could really use.  Go ahead and share it, absolutely FREE!</li>

                              <li>We’ll make sure there’s always free content available to you in the app. If you decide to buy one tiny thing for a couple dollars, it helps support the app. We would be so very grateful 🙏. Xo, Sandy. </li>  
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </section>
  </template>
  
  <script>
  export default {
    name: 'SubsPage',
    props: {
      msg: String
    }
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  h3 {
    margin: 40px 0 0;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }
  </style>
  